import {Grid} from "@material-ui/core";

import RegionSelector from "../ReportParams/RegionsSelector";
import {inject, observer} from 'mobx-react';
import DateType, {DATE_TYPE_DEFAULT} from "../ReportParams/DateType";
import React from "react";

@inject("reportFormStore")
@observer
class ReportForm extends React.Component {

    constructor(props) {
        super(props);

    }

    renderField = (name,param,getField) => {
        const { reportFormStore } = this.props;
        switch(param){
            case 'REPORT_PARAM_DATE_RANGE':
                return <DateType key={name} name={name} handleOnChange={reportFormStore.onFieldChange} currentValue={value ? value : DATE_TYPE_DEFAULT} />
            case 'REPORT_PARAM_REGIONS':
                return <RegionSelector key={name} name={name} handleOnChange={reportFormStore.onFieldChange} value={getField(name,"all")}/>
            case 'REPORT_PARAM_DATE_TYPE':
                return <DateType key={name} name={name} handleOnChange={reportFormStore.onFieldChange} currentValue={getField(name,DATE_TYPE_DEFAULT)} />
        }
    }


    render(){
        const { inputParams } = this.props;
        const { reportFormStore } = this.props;
        return (
            <Grid container>                           
                { 
                    inputParams && 
                        Object.keys(inputParams).map((key, index) => {
                            const param = inputParams[key].type;
                            // return this.renderField(key,param,reportFormStore.getField(key));
                            return this.renderField(key,param,reportFormStore.getField);
                                                
                    })
                }
            </Grid>
        )
    }
}

export default ReportForm;